"use strict";
import "lodash";
import { svc_fetchAll, svc_addOne, svc_editOne, svc_deleteOne } from "@/services";
import { showServerResponse } from "@/utils/message";
import logger from "@/utils/logger";

const endpointBasePrefix = "sectors";

const Model = {
	namespace: "m_Sectors",
	state: {
		sectors: [],
	},
	reducers: {
		handleFetchAll(state, { payload: { sectors } }) {
			return { ...state, sectors };
		},
	},
	effects: {
		*fetchAll({ payload }, { call, put }) {
			let sectors = yield call(svc_fetchAll, endpointBasePrefix);
			_.forEach(sectors, function (row) {
				row.key = row.id;
			});

			yield put({
				type: "handleFetchAll",
				payload: { sectors },
			});

			return sectors;
		},
		*addOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key","ct_isChanged","id"]);
			const response = yield call(svc_addOne, endpointBasePrefix, payload, payload.name);
			return showServerResponse(response);
		},
		*editOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key","ct_isChanged"]);
			const response = yield call(
				svc_editOne,
				endpointBasePrefix,
				payload,
				"id",
				payload.name,
			);
			return showServerResponse(response);
		},
		*deleteOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(
				svc_deleteOne,
				endpointBasePrefix,
				payload,
				"id",
				payload.name,
			);
			return showServerResponse(response);
		},
	},
	subscriptions: {},
};

export default Model;
